namespace $ { $mol_style_attach( "invite/app/app.view.css",
 ""
) }